export const GetDateString = () => {
  return `id${Date.parse(new Date())}${Math.floor(
    Math.random() * 10000
  )}`.toString();
};
